'use client'

import NumberInput from '@/components/design-system/number-input'
import MoneyFilledIcon from '@/components/icons/money-filled'
import { useTranslations } from 'next-intl'
import type { ReactNode } from 'react'

export type ProfitProps = {
  value: number
  label?: ReactNode
  rightAddon?: ReactNode
}

export default function Profit({
  value: profit,
  label,
  rightAddon: startIcon,
}: ProfitProps) {
  const t = useTranslations('originals.common.labels')

  return (
    <NumberInput
      size='lg'
      label={label ?? t('profit-on-win')}
      value={profit}
      decimalScale={2}
      readOnly
      startAdornment={<MoneyFilledIcon color='success' />}
      endAdornment={startIcon}
    />
  )
}
